import React from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import CommonToolTip from 'components/ui/tooltip/commonToolTip'
import { LargeSwitch } from 'components/ui/LargeSwitch'
import InputLabel from '../../../field/input-label/InputLabel'
import styles from '../EmailNotifications.module.scss'

interface Props {
  channel: 'email' | 'mobile'
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  disabledTooltip?: string
  trailing?: React.ReactNode
  switchTestId?: string
}

const NotificationChannelRow: React.FC<Props> = ({
  channel,
  checked,
  onChange,
  disabled = false,
  disabledTooltip,
  trailing,
  switchTestId,
}) => {
  const { t } = useTranslation()

  const label = t(
    `administration.courses.new.form.notifications.channels.${channel}`
  )
  const helper =
    channel === 'mobile'
      ? t('administration.courses.new.form.notifications.channels.mobileHelper')
      : undefined

  return (
    <div className={styles.channelBlock}>
      <div
        className={classNames('d-flex align-items-center', styles.channelRow)}
      >
        <InputLabel
          className={classNames('flex-fill mr-3 mb-0', styles.channelLabel)}
          label={label}
        />
        {trailing}
        <CommonToolTip
          text={disabledTooltip || ''}
          disabled={!disabled || !disabledTooltip}
          position="left"
        >
          <span data-test-id={switchTestId}>
            <LargeSwitch
              checked={checked}
              checkedChildren={t('administration.courses.new.form.yes')}
              unCheckedChildren={t('administration.courses.new.form.no')}
              onChange={onChange}
              disabled={disabled}
            />
          </span>
        </CommonToolTip>
      </div>
      {helper && <p className={styles.channelHelper}>{helper}</p>}
    </div>
  )
}

export default NotificationChannelRow
